import React, { useState, useEffect } from 'react';
import { FiPlusCircle, FiEdit } from "react-icons/fi"
import {Link} from "react-router-dom"

import { db, auth } from '../functions/firebaseFunctions'
const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

export default function EventsTab(props) {

    const { navigation, uid } = props;

    const [actEvents, setActEvents] = useState(null);
    const [pastEvents, setPastEvents] = useState(null);

    const [Err, setErr] = useState(null);

    useEffect(() => {
        var user = auth.currentUser;
        if (user) {
            db.collection('events').where('uid', '==', user?.uid).get()
                .then(res => {
                    if (!res.empty) {
                        const act = [];
                        const past = [];
                        const now = new Date();
                        let count = 0;
                        res.docs.forEach((item) => {

                            let value = item.data();
                            if (value) {
                                const end = value.end.toDate();
                                const date = value.start.toDate();
                                const day = date.getDate();
                                const month = months[date.getMonth()];
                                if (end > now) {
                                    act.push({
                                        id: item.id,
                                        name: value.name,
                                        type: value.type,
                                        day: day,
                                        month: month,
                                        start: value.start,
                                        end: value.end,
                                        docid: item.id,
                                    });
                                } else {
                                    past.push({
                                        id: item.id,
                                        name: value.name,
                                        type: value.type,
                                        day: day,
                                        month: month,
                                        start: value.start,
                                        end: value.end,
                                        docid: item.id,
                                    });
                                }
                                count++;
                                if (count == res.docs.length) {
                                    if (act.length > 0) {
                                        setActEvents(act);
                                    }
                                    if (past.length > 0) {
                                        setPastEvents(past);
                                    }
                                }
                            }
                        });
                    }

                }).catch((e) => { setErr(e); });
        }


    }, []);
    return (
        <div style={{display: 'flex', flexDirection: 'column',  backgroundColor: 'var(--drg)', flex: 1, paddingTop: 10,}}>
            {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
            <Link to="/edit_event/new" style={{alignSelf: 'center', color: 'white'}}>
                Create New Event
                <FiPlusCircle style={{marginLeft: 10}} />
            </Link>
            {actEvents ? <div style={{ alignItems: 'center' }}>
                <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                <div style={{ borderBottomColor: 'var(--ltg)', borderBottomWidth: 1, marginBottom: 5 }}>
                    <p style={{display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'white', width: '100%'}}>Upcoming Events:</p>
                </div>
                
                <div className='BrowseButton'  style={{flexDirection: 'column'}}>
                    {actEvents.map(item =>
                        <div style={{display: 'flex', flexDirection: 'column', width: '100%', textAlign: 'center'}}>
                            <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                                <Link to={`/event/${item.docid}`} style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                                    <div key={item?.id}
                                        // style={{fontSize: 14, marginLeft: 5,}}
                                    >
                                        <p style={{fontSize: 14, marginLeft: 5, color: 'white' }}>{item.month} {item.day} - {item.name} -  {item.type}</p>
                                        
                                    </div>
                                    
                                </Link>
                                <Link to={`/edit_event/${item.docid}`}>
                                    <div key={item?.id}
                                        // style={{fontSize: 14, marginLeft: 5,}}
                                    >
                                        <p  style={{fontSize: 14, marginLeft: 5, color: 'white' }}> <FiEdit style={{marginInlineStart: 5}}/> </p>
                                        
                                    </div>
                                </Link>
                            </div>
                        </div>
                        
                    )}
                </div>
            </div> :
                <p style={{ color: 'var(--yel)', textAlign: 'center', margin: 5 }}>Begin by creating an event</p>

            }
            {pastEvents && <div style={{ alignItems: 'center' }}>
                <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
                <div style={{ borderBottomColor: 'var(--ltg)', borderBottomWidth: 1, marginBottom: 5 }}>
                    <p className='BrowseButton' style={{ color: 'var(--ltg)' }}>Past Events:</p>
                </div>
                <div>
                    {auth.currentUser && pastEvents && pastEvents?.map(item =>
                        <div key={item?.id}
                            style={{fontSize: 14, marginLeft: 5,}}
                            onClick={() => {
                                console.log('Event', { uid: uid, item: item, eventId: item.docid, type: item.type });
                            }}
                        >
                            <p style={{fontSize: 14, marginLeft: 5, color: 'var(--ltg)',  textAlign: 'center' }}>{item.month} {item.day} - {item.name} -  {item.type}</p>
                        </div>
                    )}
                </div>
            </div>}
        </div>
    );
}
